//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    cursor: pointer;
    width: 145px;
    height: 180px;
    & figure {
        width: 100%;
        height: 100%;
        border-radius: 8px;
        position: relative;
        background-color: var(--light-2);
    }
    & h6 {
        margin: 0;
        font-size: 14px;
    }
    & input[type="checkbox"] {
        position: absolute;
        top: 10%;
        left: 10%;
    }
    & img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 15px 25px;
        border-radius: 10px;
        border: 1px solid transparent;
        transition: 0.4s;
    }
    &.selected img {
        border-color: var(--purple-1);
    }
    &.error img {
        border-color: var(--red-3);
    }
`;